import { action } from 'typesafe-actions';
import { ApiActions } from './types';

export const clearRequest = (requestName: string) => action(ApiActions.CLEAR_REQUEST, { requestName: requestName.replace('_REQUEST', '') });
export const clearAllRequests = () => action(ApiActions.CLEAR_ALL_REQUESTS);
